<form [formGroup]="createForm" matDialogContent>
  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput type="text" formControlName="name" appAutofocus />
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Commission Rate %</mat-label>
      <input matInput type="number" formControlName="commissionRate" />
    </mat-form-field>
  </div>
</form>
<div matDialogActions>
  <button
    (click)="create()"
    [disabled]="createForm.invalid"
    mat-raised-button
    color="primary"
    type="button"
    matDialogClose
  >
    Create
  </button>
  <button mat-button type="button" color="primary" matDialogClose>Cancel</button>
</div>
